import React, { useState, useEffect } from 'react';
import { Button, Card, CardBody, Input, Label } from 'reactstrap';
import { Separator, Colxx } from '../../../../../../components/common/CustomBootstrap';
export default function SecuritySettings({
  securitySettings,
  saveIntegration,
}) {
  const [dailyCallLimit, setDailyCallLimit] = useState(
    securitySettings?.dailyCallLimit !== undefined
      ? securitySettings?.dailyCallLimit
      : 500
  );
  const [concurrentCallLimit, setConcurrentCallLimit] = useState(
    securitySettings?.concurrentCallLimit !== undefined
      ? securitySettings?.concurrentCallLimit
      : -1
  );

  useEffect(() => {
    setDailyCallLimit(
      securitySettings?.dailyCallLimit !== undefined
        ? securitySettings?.dailyCallLimit
        : 500
    );
    setConcurrentCallLimit(
      securitySettings?.concurrentCallLimit !== undefined
        ? securitySettings?.concurrentCallLimit
        : -1
    );
  }, [securitySettings]);

  const handleDailyCallLimitChange = (e) => {
    const value = e.target.value;
    setDailyCallLimit(value);
  };

  const handleConcurrentCallLimitChange = (e) => {
    const value = e.target.value;
    setConcurrentCallLimit(value);
  };

  const handleSave = () => {
    let security = {
      dailyCallLimit: dailyCallLimit,
      concurrentCallLimit: concurrentCallLimit,
    };
    saveIntegration({ security: security });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Keep your Voice AI Secure</h6>
        </div>
        <Separator className="mb-3" />
        <Card className="m-4">
          <Colxx xxs="12" className="pl-4 py-3">
            <div className="mb-2">
              <div className="mt-2">
                <h6>Daily call limit</h6>
                <p className="mb-1">The maximum number of calls allowed per day. (-1 for no limit)</p>
                <div className="d-flex">
                  <Input
                    type="number"
                    name="dailyCallLimit"
                    className="form-control"
                    value={dailyCallLimit}
                    style={{ width: '70%' }}
                    onChange={handleDailyCallLimitChange}
                    min={-1}
                  />
                </div>
              </div>
              <div className="mt-3">
                <h6>Concurrent call limit</h6>
                <p className="mb-1">
                  The maximum number of concurrent calls allowed. (-1 for no limit)
                </p>
                <div className="d-flex">
                  <Input
                    type="number"
                    name="concurrentCallLimit"
                    className="form-control"
                    style={{ width: '70%' }}
                    value={concurrentCallLimit}
                    onChange={handleConcurrentCallLimitChange}
                    min={-1}
                  />
                </div>
              </div>
            </div>
          </Colxx>
        </Card>
        <Separator className="my-3" />
        <div className="text-center mt-4 mb-2">
          <Button color="primary" size="xs" onClick={handleSave}>
            Save
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
